<template>
  <section class="waybills-list-wrapper">
    <div class="waybills-list-filter px-1">
      <form @submit.prevent="filterResults">
        <div class="row align-items-end border rounded py-2 mb-2">
          <div class="col-12 col-sm-6 col-lg-9">
            <label for="waybills-list-verified">Ara</label>
            <fieldset class="form-group mb-0">
              <input class="form-control" id="waybills-list-verified" v-model="search" />
            </fieldset>
          </div>
          <div class="col-12 col-sm-6 col-lg-3 d-flex align-items-center">
            <button type="button" @click="filterResults" class="btn btn-primary btn-block glow waybills-list-clear mt-0">{{  $t('general.filter') }}</button>
            <button type="button" @click="resetFilters" class="btn btn-primary btn-block glow waybills-list-clear mt-0 ml-1">{{  $t('general.clear') }}</button>
          </div>
        </div>
      </form>
    </div>
    <div class="waybills-list-table">
      <div class="card">
        <div class="card-body">
          <!-- datatable start -->
          <div class="table-responsive">
            <data-table
                tableVariant="''"
                :hover="false"
                :outlined="false"
                :striped="false"
                :no-border-collapse="true"
                :borderless="true"
                :bordered="false"
                @onClickDelete="onClickDelete"
                @onClickEdit="onClickEdit"
                :items="formattedItems"
                :fields="fields"
                :per-page.sync="per_page"
                :page.sync="page"
                :paginate="items"
            ></data-table>

          </div>
          <!-- datatable ends -->

          <add-button @onClick="onClickAdd" />

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DataTable from "@/assets/components/dataTable/DataTable";
import inputFilter from "@/assets/components/filters/InputFilter";
import addButton from "@/assets/components/dataTable/AddButton";
import baseModule, {
  ERROR,
  ITEMS,
  LOADING,
  MODULE_NAME as BASE_MODULE,
  DELETE_ITEM,
  SUCCESS,
  GET_ITEMS
} from "@/core/services/store/waybill.module";
import store from "@/core/services/store";

const _BASE_MODULE = BASE_MODULE;

import {
  LARAVEL_DATE_TIME_FORMAT,
} from "@/core/config/constant";
import moment from "moment";

export default {
  name: "WaybillIndex",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_BASE_MODULE, baseModule);
  },
  components: {
    DataTable,
    DashboardBox,
    inputFilter,
    addButton
  },
  computed: {
    error() {
      return store.getters[_BASE_MODULE + "/" + ERROR];
    },
    loading() {
      return store.getters[_BASE_MODULE + "/" + LOADING];
    },
    success() {
      return store.getters[_BASE_MODULE + "/" + SUCCESS];
    },
    items() {
      return store.getters[_BASE_MODULE + "/" + ITEMS];
    },
    filters() {
      return {
        per_page: this.per_page,
        page: this.page,
        search: this.search,
        order: this.order,
        sort: this.sort
      };
    },
    formattedItems() {
      let results = [];
      if (
        this.items === null ||
        this.items.data === null ||
        this.items.data === undefined
      )
        return [];

      this.items.data.forEach(item => {
        let createdAt = item.waybill_date
          ? moment(item.waybill_date, LARAVEL_DATE_TIME_FORMAT)
          : moment();

        results.push({
          id: item.id,
          document_number: item.document_number,
          waybill_date: item.waybill_date,
          amount: item.amount,
          transaction_type: +item.transaction_type === 1 ? this.$t('waybills.entrance') : this.$t('waybills.out')
        });
      });

      return results;
    }
  },
  data() {
    return {
      page: 1,
      per_page: 10,
      sort: "id",
      order: "desc",
      search: "",
      fields: [
        {
          key: "id",
          label: this.$t("waybills.id"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "transaction_type",
          label: this.$t("waybills.transaction_type"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "document_number",
          label: this.$t("waybills.document_number"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "amount",
          label: this.$t("waybills.amount"),
          sortable: false,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "waybill_date",
          label: this.$t("waybills.waybill_date"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "actions",
          label: this.$t("waybills.actions"),
          sortable: false,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
      ]
    };
  },
  methods: {
    filterResults() {
      if (this.loading) {
        return;
      }
      this.$store.dispatch(_BASE_MODULE + '/' + GET_ITEMS, {
          filters: this.filters,
        });
    },
    onClickDelete(id) {
      this.sweetAlertConfirm(
        this.$t("general.are_you_sure"),
        function(self) {
          let payload = {
            id: id
          };
          self.$store.dispatch(_BASE_MODULE + "/" + DELETE_ITEM, payload);
        });
    },
    onClickAdd() {
      this.$router.push({ name: 'store.waybills.create' })
    },
    onClickEdit(id) {
      this.$router.push({ name: "store.waybills.edit", params: { id: id } });
    },
    filterResult() {
      this.$store.dispatch(_BASE_MODULE + "/" + GET_ITEMS, {
        url: this.url,
        filters: this.filters
      });
    },
    resetFilters() {
      this.search = "";
      this.filterResults();
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t("general.dashboard"), route: "dashboard" },
      { title: this.$t("waybills.self") }
    ]);

    this.filterResults();
  },
  watch: {
    sort() {
      this.filterResults();
    },
    order() {
      this.filterResults();
    },
    per_page() {
      this.filterResults();
    },
    success(value) {
      let self = this;
      if (value) {
        setTimeout(() => {
          self
              .sweetAlertSuccess(self.$t("general.successfully_saved"), (response) => {
                if (response) {
                  this.filterResults();
                }
              });
        }, 500)
      }
    }
  }
};
</script>

<style>
.filter-card {
  background: white;
  border-radius: 25px !important;
  padding: 20px;
}
</style>
